export default __webpack_public_path__ + "static/food-edd06db946a3adb866e45a69c896ae79.webp";